import { GET_QUERY_KEY, QUERY_OPTIONS } from "../common/constants";

import { LookupFieldService } from "../services/LookupFieldService";
import { useQuery } from "@tanstack/react-query";

export const useGetLookupFieldData = (lookupFieldId: string) =>
  useQuery({
    queryKey: [GET_QUERY_KEY.LOOKUP_FIELD_DATA_BY_ID, lookupFieldId],
    queryFn: () => {
      return LookupFieldService.getByIdd(lookupFieldId);
    },
    refetchOnWindowFocus: false,
  });
